export const ID = '41c62dec-3a21-43a9-a297-29d9cd61d150';

export const NAME = 'Storage Calculator';
